import React, {
  useCallback,
  useContext,
  createContext,
  useState,
  useMemo,
} from 'react';
import api from 'services';

const RegImagesContext = createContext({});

export function RegImagesProvider({ children }) {
  const [regImages, setRegImages] = useState([]);
  const [regImagesLoading, setRegImagesLoading] = useState(false);

  const [regImage, setRegImage] = useState({});
  const [regImageLoading, setRegImageLoading] = useState(false);

  const getRegImages = useCallback(async (registroId) => {
    try {
      setRegImagesLoading(true);
      const response = await api.regAtividade().getRegImages(registroId);
      setRegImages(response);
    } catch (errors) {
    } finally {
      setRegImagesLoading(false);
    }
  }, []);

  const getRegImage = useCallback(async (registroId, id) => {
    try {
      setRegImageLoading(true);
      const response = await api.regAtividade().getRegImage(registroId, id);
      setRegImage(response);
    } finally {
      setRegImageLoading(false);
    }
  }, []);

  const contextValue = useMemo(
    () => ({
      getRegImages,
      regImages,
      regImagesLoading,
      getRegImage,
      regImage,
      regImageLoading,
    }),
    [
      getRegImages,
      regImages,
      regImagesLoading,
      getRegImage,
      regImage,
      regImageLoading,
    ],
  );

  return (
    <RegImagesContext.Provider value={contextValue}>
      {children}
    </RegImagesContext.Provider>
  );
}

export function useRegImages() {
  const context = useContext(RegImagesContext);

  if (!context)
    throw new Error('useRegImages must be used within an useRegImages');

  return context;
}
